import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "closeable"];
import { filterProps } from '../../../utils/filterProps';
import { Alert } from '../AlertLegacy';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingAlert = _ref => {
  let {
      children,
      closeable = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(Alert, Object.assign({}, rest, {
    closeable: closeable,
    floating: true
  }, domProps, {
    children: children
  }));
};
export default FloatingAlert;